'use client';
import { createStyles, rem } from '@s7/styles';

var useStyles = createStyles({
    panel: {
        wordBreak: 'break-word'
    },
    content: {
        marginBottom: rem(20)
    }
});

export { useStyles as default };
//# sourceMappingURL=AccordionPanel.styles.js.map
